// Aviso de "los carritos han cambiado", para que el contador del menú no espere.
//
// Reporte del usuario (19-ago): "el icono numérico del menú carritos tarda un poco
// en aparecer". La barra lateral pide la cuenta al cargar y luego cada 60 s, y
// además al volver a la pestaña — pero navegar DENTRO de la app no dispara eso: la
// pestaña nunca se fue. Así que creabas un carrito en el Dispensario y el número
// podía tardar hasta un minuto.
//
// Un evento del navegador y no un contexto a propósito: `UserContext` es un array
// posicional con decenas de consumidores, y meter aquí un valor más obliga a
// tocarlo. Esto lo emite quien escribe un carrito y lo escucha quien lo cuenta,
// sin que ninguno de los dos conozca al otro. El sondeo de 60 s se queda como red
// de seguridad por si algún camino nuevo se olvida de avisar.
const EVENTO = 'wa:carritos-cambiaron';

export function avisarCarritosCambiados() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(EVENTO));
}

/** Devuelve la función para dejar de escuchar (para el cleanup del efecto). */
export function alCambiarCarritos(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENTO, handler);
  return () => window.removeEventListener(EVENTO, handler);
}
